import { sortBy } from 'lodash';
import countryCodes from 'country-codes-list';

export const callingCodes = [
    { value: '', label: 'Select a Country Code' },
    ...sortBy(countryCodes.all(), 'countryNameEn').map(
        ({ countryCallingCode, countryNameEn, countryCode }) => ({
            value: `${countryCode}/${countryCallingCode}`,
            label: `${countryNameEn} +${countryCallingCode}`,
        }),
    ),
];

export const franchiseMap: {
    [key: string]: { label?: string; color: string };
} = {
    'CashBuild South Africa': {
        label: 'CB South Africa',
        color: 'blue',
    },
    'PNL South Africa': {
        label: 'PNL South Africa',
        color: 'cyan',
    },
    'CashBuild Botswana': {
        label: 'CB Botswana',
        color: 'teal',
    },
    'CashBuild Lesotho': {
        label: 'CB Lesotho',
        color: 'green',
    },
    'CashBuild Malawi': {
        label: 'CB Malawi',
        color: 'yellow',
    },
    'CashBuild Namibia': {
        label: 'CB Namibia',
        color: 'orange',
    },
    'CashBuild Swaziland': {
        label: 'CB Swaziland',
        color: 'pink',
    },
    'CashBuild Zambia': {
        label: 'CB Zambia',
        color: 'violet',
    },
    default: {
        color: 'gray',
    },
};

export function getFranchiseObject(franchise: string) {
    if (!franchiseMap[franchise]) {
        return {
            ...franchiseMap.default,
            label: franchise,
        };
    }
    return franchiseMap[franchise];
}

export const ACCESS_TOKEN_KEY = 'accessToken';
